import { Temporal } from 'temporal-polyfill'
import type { Movie } from '../../api_types.ts'

export function formatFullDate(zdt: Temporal.ZonedDateTime | Temporal.PlainDate): string {
  const day = zdt.day;
  const ordinal =
    day % 10 === 1 && day !== 11 ? 'st' :
      day % 10 === 2 && day !== 12 ? 'nd' :
        day % 10 === 3 && day !== 13 ? 'rd' : 'th';
  const weekday = zdt.toLocaleString('en-US', { weekday: 'long' });
  const month = zdt.toLocaleString('en-US', { month: 'long' });
  return `${weekday}, ${day}${ordinal} ${month}`;
}

export function groupMoviesByDate(movies?: Movie[]) {
  return Object.groupBy(movies || [], movie => {
    if (!movie.times[0]) return ''
    return Temporal.Instant
      .from(movie.times[0].time)
      .toZonedDateTimeISO(Temporal.Now.timeZoneId())
      .toPlainDate()
      .toString()
  })
}